import React from "react";
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";

const SortButton = ({ column, currentSortColumn, currentSortOrder, onSortChange }) => {
  const isActive = column === currentSortColumn;
  const isAscending = currentSortOrder === "asc";

  const handleClick = () => {
    const newOrder = isActive && isAscending ? "desc" : "asc";
    onSortChange(column, newOrder);
  };

  return (
    <span onClick={handleClick} style={{ cursor: "pointer" }}>
      {isActive ? (
        isAscending ? <FaSortAmountUp className="sort-icon active-sort" /> : <FaSortAmountDown className="sort-icon active-sort" />
      ) : (
        <FaSortAmountUp className="sort-icon default-sort" />
      )}
    </span>
  );
};

export default SortButton;
